import { Routes, Route, Navigate } from 'react-router-dom';
import RequireAdmin from '@/auth/RequireAdmin';
import AppLayout from '@/layout/AppLayout';
import LoginPage from '@/features/auth/LoginPage';
import DashboardPage from '@/features/dashboard/DashboardPage';
import BetaAllowlistPage from '@/features/betaAllowlist/BetaAllowlistPage';
import VideosPage from '@/features/videos/VideosPage';
import StripePage from '@/features/stripe/StripePage';
import UsersPage from '@/features/users/UsersPage';
import ZonesPage from '@/features/zones/ZonesPage';
import ThemesPage from '@/features/themes/ThemesPage';
import GuidancePage from '@/features/guidance/GuidancePage';
import WorkoutsPage from '@/features/workouts/WorkoutsPage';
import CyclesPage from '@/features/cycles/CyclesPage';
import CycleDetailPage from '@/features/cycles/CycleDetailPage';
import PlansPage from '@/features/plans/PlansPage';
import PlanComposerPage from '@/features/plans/PlanComposerPage';
import SimulatorPage from '@/features/simulator/SimulatorPage';
import MigrationPage from '@/features/migration/MigrationPage';
import ScalingPage from '@/features/scaling/ScalingPage';

const App = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />

    <Route element={<RequireAdmin />}>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/zones" element={<ZonesPage />} />
        <Route path="/themes" element={<ThemesPage />} />
        <Route path="/guidance" element={<GuidancePage />} />
        <Route path="/scaling" element={<ScalingPage />} />
        <Route path="/workouts" element={<WorkoutsPage />} />
        <Route path="/cycles" element={<CyclesPage />} />
        <Route path="/cycles/:id" element={<CycleDetailPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/plans/create" element={<PlanComposerPage />} />
        <Route path="/plans/edit/:uuid" element={<PlanComposerPage />} />
        <Route path="/simulator" element={<SimulatorPage />} />
        <Route path="/migration" element={<MigrationPage />} />
        <Route path="/videos" element={<VideosPage />} />
        <Route path="/stripe" element={<StripePage />} />
        <Route path="/beta-allowlist" element={<BetaAllowlistPage />} />
      </Route>
    </Route>

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;
